import React from "react";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import Body from "./body/Body";
import headerStyle from "../style/header/Header.module.css";
import footerStyle from "../style/footer/Footer.module.css";
import bodyStyle from "../style/body/Body.module.css";

const MainComponent = () => {
  return (
    <div>
      <div className={headerStyle.header_container}>
        <Header />
      </div>
      <div className={` ${bodyStyle.body_container}`}>
        <Body />
      </div>
      <div className={`${footerStyle.footer_container}`}>
        <Footer />
      </div>
    </div>
  );
};

export default MainComponent;
